import axios from 'axios'

const client = axios.create({
  baseURL: process.env.BEDROCK_API_HOST
})

const googleUserInfoInstance = axios.create({
  baseURL: 'https://www.googleapis.com/oauth2/v2'
})

const basicAuthHeader = `Basic ${btoa(
  `${process.env.BEDROCK_API_CLIENT_TOKEN}:${process.env.BEDROCK_API_CLIENT_SECRET}`
)}`

export default {
  client,
  basicAuthHeader,
  googleUserInfoInstance
}
